import axios from "axios";

// Use a SAME-ORIGIN relative base so credentialed auth cookies are always first-party.
// This works in preview and on every deployed domain (apex, www, default host) and
// avoids cross-origin CORS + third-party SameSite=None cookie failures on custom domains.
export const API = "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Keep-me-logged-in: transparently refresh an expired access token using the refresh
// cookie, then retry the original request once.
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    const skip =
      url.includes("/auth/refresh") ||
      url.includes("/auth/login") ||
      url.includes("/auth/register");
    if (error.response?.status === 401 && !original._retry && !skip) {
      original._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
